import React from 'react';
import { observer } from 'mobx-react-lite';
import ConfirmModalBase from '../ConfirmModalBase';

const DuplicateModal = observer(({
    isOpen,
    store,
    onClose,
    onConfirm
}) => {
    return (
        <ConfirmModalBase
            isOpen={isOpen}
            onClose={onClose}
            onConfirm={onConfirm}
            title={store.duplicateModalTitle}
            description={store.duplicateModalDescription}
            confirmLabel="Duplicate"
            cancelLabel="Cancel"
            isLoading={store.foldersStore.isCreatingFolder || store.documentsStore.isLoading}
        />
    );
});

export default DuplicateModal;
